class TechnicalInfo extends HTMLElement {
  constructor() {
    super();
    this.rows = []
    this.rowsData = []
    this.init();
    this.classes = {
      hidden: 'hidden'
    }
    this.resizing = false
  }

  buildRowData() {
    if (!this.rows.length) {
       return
    }
    return Array.from(this.rows).map((row) => {
      const columns = row.querySelectorAll('th,td')
      if (!columns) { return }
      const columnsData = Object.fromEntries(
        Array.from(columns).map((col) => {
          const { id, value } = col.dataset
          return [
            id, value
          ]
        })
      );
      return  {
        "tr": row,
        "id": row.dataset.id,
        ...columnsData
      }
    })
  }

  setRows() {
    this.rows = this.querySelectorAll('tr[data-id^=row-product--] ')
    if (!this.rows.length) { return }
    this.rowsData = this.buildRowData()
  }

  setOrderedColumn() {
    this.orderedColumn = this.querySelector('[aria-sort]')
  }

  setColumns() {
    this.setOrderedColumn()
    this.columnsHeaders = this.querySelectorAll('thead th.tech-info-table__sizes')
  }

  sortRowsData(columnId = null, direction = 'ascending') {
    if (!columnId || !this.rows || this.rows.length == 0) {
      return
    }
    this.rowsData = this.rowsData.sort((a, b) => {
      let fa = a[columnId].toLowerCase(),
          fb = b[columnId].toLowerCase();
      if (!isNaN(fa) && !isNaN(fb)) {
        return direction === 'ascending' ? fa - fb : fb - fa;
      }
      if (fa < fb) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (fa > fb) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  }

  orderRows(columnId = null, direction = 'ascending') {
    if (!columnId || !this.rows.length) { return }
    this.sortRowsData(columnId, direction);
    this.rowsData.map(({ tr }) => this.querySelector('tbody').appendChild(tr))
  }

  renderSelectedProduct(row) {
    const { sectionId } = this.dataset
    fetch(`${row.dataset.url}?&section_id=${ sectionId }`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const source = html.getElementById(`technicalInfoSelectedProduct`);
      const destination = document.getElementById('technicalInfoSelectedProduct')
      const tech_img_source = html.getElementById('tech-info__image');
      const tech_img_destination = document.getElementById('tech-info__image')
      if (source && destination) {
        destination.innerHTML = source.innerHTML
      }
      if (tech_img_source && tech_img_destination) {
        tech_img_destination.innerHTML = tech_img_source.innerHTML
      }
    })
  }

  onRowClicked(event) {
    const { target, currentTarget } = event;
    console.log(target);
    console.log(currentTarget);
    const selected =   target.closest('tbody').querySelector(`.${this.selectedClass}`)
    selected.classList.remove(...this.selectedClasses)
    const row = target.closest('tr');
    row.classList.add(...this.selectedClasses);
    this.renderSelectedProduct(row)
  }

  rowSelectEventListeners() {
    const radios = this.querySelectorAll('input[type="radio"]')
    Array.from(radios).forEach(radio => radio.addEventListener('change', function (event) {
      this.onRowClicked(event)
    }.bind(this)))
  }

  onColumnHeaderClicked(event) {
    const ariaSort = 'aria-sort'
    const descending = 'descending';
    const ascending = 'ascending';
    const { target } = event
    const { id } = target.dataset 
    const currentOrder = target.getAttribute(ariaSort);
    if (currentOrder !== null) {
      const newOrder = currentOrder === ascending ? descending : ascending
      this.orderRows(id, newOrder)
      target.setAttribute(ariaSort, newOrder)
      return 
    }
    this.orderedColumn.removeAttribute(ariaSort)
    target.setAttribute(ariaSort, ascending)
    this.setOrderedColumn()
    this.orderRows(id, ascending)
  }

  columnEventListeners() {
    Array.from(this.columnsHeaders).forEach(th => th.addEventListener('click', function (event) {
      this.onColumnHeaderClicked(event)
    }.bind(this)))
  }

  setSelectedClasses( ) {
    const { selectedClasses } = this.dataset
    const additionalClasses = selectedClasses.split(' ')
    if (!additionalClasses.length) {
      return
    }
    this.selectedClasses = [...this.selectedClasses, ...additionalClasses]
  }

  setScrollWidth(width = null) {
    const newWidth = width ? `${width}px` : null;
    this.scrollEl.style.width =  newWidth;
  }

  onScroll(event) {
    const { target } = event
    let updateScrollEl = this.tableEl
    if (target === this.tableEl) {
      updateScrollEl = this.scrollerEl
    }
    updateScrollEl.scrollLeft = target.scrollLeft
  }

  onClickScroll(flag) {
    let updateScrollEl = this.tableEl;
    const scrollAmount = 40;
    if (flag === 'left') {
      updateScrollEl.scrollLeft -= scrollAmount;
    }
    if (flag === 'right') {
      updateScrollEl.scrollLeft += scrollAmount;
    }
  }

  needsScrollers() {
    const { width } = this.scrollerEl.parentElement.getBoundingClientRect();
    const { scrollWidth } =  this.tableEl;
    return width < scrollWidth
  }

  showEl(el = null) {
    if (!el) { return }
    el.classList.remove('hidden')
  }

  hideEl(el = null) {
    if (!el) { return }
    el.classList.add('hidden')
  }

  hideScrollers() {
    this.tableEl.classList.remove('tech-info__table--scrollable')
    this.hideEl(this.scrollerEl)
    this.hideEl(this.swipeInstructionsEl)
  }

  showScrollers() {
    this.tableEl.classList.add('tech-info__table--scrollable')
    this.setScrollWidth(this.tableEl.scrollWidth);
    this.showEl(this.scrollerEl)
    this.showEl(this.swipeInstructionsEl)
  }

  showHideScrollers() {
    this.needsScrollers() ?
      this.showScrollers() :
      this.hideScrollers()
  }

  onResize() {
    // clear the timeout
    clearTimeout(this.resizing);
    // start timing for event "completion"
    this.resizing = setTimeout(this.showHideScrollers(), 200);
  }

  initScrollers() {
    if (!this.scrollEl && !this.tableEl) {
      return
    }
    this.showHideScrollers()
    window.addEventListener("resize", this.onResize.bind(this));
    this.scrollerEl.addEventListener('scroll', this.onScroll.bind(this))
    this.tableEl.addEventListener('scroll', this.onScroll.bind(this))
    this.scrollerBtnLeft.addEventListener('click', this.onClickScroll.bind(this, 'left'))
    this.scrollerBtnRight.addEventListener('click', this.onClickScroll.bind(this, 'right'))
  }

  init() {
    this.setRows()
    this.setColumns()
    if (!this.rows.length || !this.columnsHeaders.length) {
      return
    }
    this.selectedClass = 'is-selected'
    this.selectedClasses = [this.selectedClass]
    this.setSelectedClasses()
    const firstSizeColumn = this.columnsHeaders[0]
    this.orderRows(firstSizeColumn.dataset.id);
    this.rowSelectEventListeners()
    this.columnEventListeners()
    this.scrollerEl = this.querySelector('.tech-info__scroller')
    this.scrollEl = this.querySelector('.tech-info__scroll')
    this.tableEl = this.querySelector('.tech-info__table')
    this.swipeInstructionsEl = this.querySelector('.tech-info-table__instructions')
    this.scrollerBtnLeft = this.querySelector('#tech-info__scroller-left')
    this.scrollerBtnRight = this.querySelector('#tech-info__scroller-right')
    this.initScrollers()
  }
}

customElements.define('technical-info', TechnicalInfo);
